import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs } from 'antd';
import EmployeePositionMapping from './EmployeePositionMapping';
import ListUser from './index';
import PermissionEmployee from 'Page/PermissionEmployee';
import CreateAssignmentHistory from './CreateAssignmentHistory';
import { ALL_PERMISSION } from 'constants/permission';
import BasicTabs from 'components/BasicTabs';

const { TabPane } = Tabs;

const ManageRegistration = () => {
  const { t: translation } = useTranslation()
  const listTab = [{
    key: "management",
    label :translation("management.tab.management"),
    permission: undefined,
    component: <ListUser />,
  },
  {
    key: "assignment",
    label :translation("management.tab.assignment"),
    permission: undefined,
    component: <EmployeePositionMapping />,
  },
  {
    key: "authority",
    label :translation("management.tab.authority"),
    permission: undefined,
    component: <PermissionEmployee />,
  },
  {
    key: "createAssignmentHistory",
    label :translation("management.tab.createAssignmentHistory"),
    permission: undefined,
    component: <CreateAssignmentHistory />,
  }
]
  return (
    <BasicTabs tabs={listTab} permissionConstant={ALL_PERMISSION.MANAGE_APP_USER.permissionTab} />
  );
};

export default ManageRegistration;
